import reduceReducers from 'reduce-reducers';
import { combineReducers, Reducer } from 'redux';

import { ActionType } from '../../../store/actionTypes';
import { AppAction } from '../../../store/types';
import {
  createPaginatedReducer,
  PaginatedCollectionState,
} from '../shared/collection';

export interface VariablesState {
  view: PaginatedCollectionState;
}

const variableCollectionReducer = createPaginatedReducer({
  started: ActionType.FETCH_VARIABLE_LIST_STARTED,
  succeeded: ActionType.FETCH_VARIABLE_LIST_SUCCEEDED,
  failed: ActionType.FETCH_VARIABLE_LIST_FAILED,
});

const variableCollectionExtendedReducer = function (
  state: PaginatedCollectionState,
  action: AppAction,
): PaginatedCollectionState {
  // Reset cache when a new variable is created
  if (action.type === ActionType.CREATE_VARIABLES_SUCCEEDED) {
    return {};
  }
  return state;
};

const variablesViewReducer: Reducer<PaginatedCollectionState> = reduceReducers(
  variableCollectionReducer,
  variableCollectionExtendedReducer,
);

const variablesReducer: Reducer<VariablesState> =
  combineReducers<VariablesState>({
    view: variablesViewReducer,
  });

export default variablesReducer;
